export enum CookieName {
  ModeConfig = 'mode-config',
  FeaturesOptions = 'feature_options',
  AdditionalSymbolInfo = 'symbol_info',
}

export interface ICookieService {
  get(name: CookieName): string | undefined;
}
